module.exports = __webpack_public_path__ + "img/great_communication.f7aeb62c.svg";